import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser, selectGreenhouse, useGreenhouseActions } from 'state';
import { API } from '../../api';
import { Header } from '../../components/Header';
import {
  PageWrapper,
  Container,
  RightBlock,
  LogItem,
  LogDetails,
  EmptyMessage
} from './AlertLogs.styles';
import { PaginationBlock, Title } from '../Upload/Upload.styles';
import { Pagination } from '../../components/_shared/Pagination';
import { StyledSelect } from '../Scanning/Scanning.styles';
import { Filters } from '../../components/UsageStatistic/UsageStatistic.styles';
import { getISOWeekDateRange } from '../../components/CanopyDetection/helpers';
import {
  ButtonWrapper,
  FilterButton,
  SelectOption
} from '../../components/CanopyDetection/CanopyDetection.styles';
const AlertLogs = () => {
  const user = useSelector(selectUser);
  const customer = user?.customer?.[0]?.external_id;
  const { locations, selectedGreenhouse } = useSelector(selectGreenhouse);
  const { getLocations } = useGreenhouseActions();
  const [dataCount, setDataCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    if (!locations.length) getLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [location, setLocation] = useState();
  const [week, setWeek] = useState();
  const CHECK_TYPE_MAP = {
    gtp: 'Greater than previous',
    ltp: 'Less than previous',
    gte: 'Greater than or equal',
    lte: 'Less than or equal'
  };
  const FIELD_OPTIONS_MAP = {
    canopy_percentage: 'Canopy Percentage',
    induction_per_m2: 'Induction per m²',
    yellow_leaves_per_m2: 'Yellow Leaves per m²',
    brown_leaves_per_m2: 'Brown Leaves per m²'
  };
  const [logs, setLogs] = useState([]);
  const toggleLog = log => {
    setLogs(
      logs.map(l => (l.id === log.id ? { ...l, open: !l.open, status: 'READ' } : l))
    );
    log.status === 'UNREAD' && markViewed(log.id);
  };
  const weekSelectItems = year => {
    function mapCB(_, i) {
      const { start, end } = getISOWeekDateRange(i + 1, year);
      const option = `${i + 1} week (${start} - ${end})`;
      return {
        name: <SelectOption isActive={true}>{option}</SelectOption>,
        value: i + 1,
        start: start,
        end: end,
        option
      };
    }

    return [...Array(52)].map(mapCB);
  };
  const current_year = new Date().getFullYear();

  const markViewed = id => {
    markAsViewed(id);
  };
  const [alertsCount, setAlertsCount] = useState();

  const getAlertsCount = customer => {
    API.alert.getAlertLogsCount(customer).then(({ data }) => {
      setAlertsCount(data.count);
    });
  };
  const getAlertLogs = (customer, location, start, end, page) => {
    API.alert.getAlertLogs(customer, location, start, end, page).then(({ data }) => {
      setLogs(data.results.logs);
      setDataCount(data.count);
      setCurrentPage(page);
    });
  };
  const markAsViewed = uuid => {
    API.alert
      .markAlertAsViewed(uuid)
      .then(() => getAlertsCount(customer, selectedGreenhouse));
  };
  useEffect(() => {
    if (customer) {
      getAlertLogs(customer, null, null, null, currentPage);
    }
  }, [customer]);

  const handleClearFilter = () => {
    setWeek(null);
    setLocation(null);
    setCurrentPage(1);
    getAlertLogs(customer, null, null, null, 1);
  };

  return (
    <>
      <Header alertsCount={alertsCount} />
      <PageWrapper>
        <Container>
          <Filters>
            <StyledSelect
              value={location}
              items={locations.map(x => ({ name: x.name, value: x.id }))}
              onSelect={({ value }) => {
                setCurrentPage(1);
                setLocation(value);
                getAlertLogs(
                  customer,
                  value,
                  week ? week.start : null,
                  week ? week.end : null,
                  1
                );
              }}
              placeholder={'Select Location'}
            ></StyledSelect>
            <StyledSelect
              value={week?.value}
              items={weekSelectItems(current_year)}
              onSelect={value => {
                setCurrentPage(1);
                setWeek(value);
                getAlertLogs(customer, location ?? null, value.start, value.end, 1);
              }}
              placeholder={'Select Week'}
            ></StyledSelect>
            <ButtonWrapper>
              <FilterButton
                fullWidth
                variant='secondary'
                variantType='danger'
                icon='Delete'
                onClick={handleClearFilter}
              >
                Clear filter
              </FilterButton>
            </ButtonWrapper>
          </Filters>
          <RightBlock>
            <Title>Alert Logs</Title>
            {logs.map(log => (
              <LogItem key={log.id}>
                <div onClick={() => toggleLog(log)}>
                  <strong>
                    {log.location__name} — {log.flight_date} —{' '}
                    {FIELD_OPTIONS_MAP[log.alert__field]} —{' '}
                    {CHECK_TYPE_MAP[log.alert__check_type]} — {log.status}
                  </strong>
                </div>
                {log.open && (
                  <LogDetails>
                    <p>
                      {log.alert_message.split('\n').map((line, i) => (
                        <span key={i}>
                          {line} <br />
                        </span>
                      ))}
                    </p>
                  </LogDetails>
                )}
              </LogItem>
            ))}
            {dataCount !== 0 && (
              <PaginationBlock>
                <Pagination
                  currentPage={currentPage}
                  count={dataCount}
                  onSelectCallback={page =>
                    getAlertLogs(
                      customer,
                      location ?? null,
                      week ? week.start : null,
                      week ? week.end : null,
                      page
                    )
                  }
                />
              </PaginationBlock>
            )}
            {dataCount === 0 && (
              <EmptyMessage>There are no alert logs to display</EmptyMessage>
            )}
          </RightBlock>
        </Container>
      </PageWrapper>
    </>
  );
};
export default AlertLogs;
